import {
  FETCH_SERVICE_CASES,
  UNSET_FETCH_SERVICE_CASES,
  SET_FETCH_SERVICE_CASES,
} from 'actions';
import Notifier from 'common/helpers/Notifier';
import { coreApi } from 'src/api/config';
import {
  includePathwaysServices,
  crtb2646ShowProgramNameReferralsCasesDashboard,
} from 'common/utils/FeatureFlags/flags';
import _ from 'lodash';
import {
  DEFAULT_PERSON_CASE_STATE,
  DEFAULT_PERSON_CASE_INTERNAL_STATE,
} from './caseStateFilters';

export default function fetchServiceCases (
  groupId,
  contactId,
  options = {
    page: 1,
    sortBy: 'updated_at',
    sortDirection: 'desc',
  },
) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SET_FETCH_SERVICE_CASES });
      const state = getState();
      const includePathways = includePathwaysServices(state) || false;
      const showProgramName = crtb2646ShowProgramNameReferralsCasesDashboard(state);
      const response = await coreApi.query('case', {
        person: contactId,
        state: DEFAULT_PERSON_CASE_STATE,
        include_pathways: includePathways,
        internal_state: DEFAULT_PERSON_CASE_INTERNAL_STATE,
      }, {
        page: {
          number: options.page,
          size: options.size || 50,
        },
        sort: options.sortBy,
        sort_direction: options.sortDirection,
        ...(showProgramName ? { include: 'program_name' } : null),
      });
      const cases = response.data.data;

      await Promise.all([
        coreApi.populateRelationship('service', 'service', cases, {
          customQuery: (modelName, ids) => coreApi.query(modelName, {
              ids,
              include_pathways: includePathways,
          }).then((res) => ({ data: { data: _.get(res, 'data.data', []) } })),
        }),
        coreApi.populateRelationship('provider', 'provider', cases),
        coreApi.populateRelationship('primary_worker', 'employee', cases),
        coreApi.populateRelationship('program', 'program', cases, {
          customQuery: (modelName, ids) => {
            const maxChunkSize = 50;

            if (ids.length <= maxChunkSize) {
              return coreApi.query(modelName, {
                ids,
                include_pathways: includePathways,
              }, { page: { number: 1, size: ids.length } });
            }

            const chunks = _.chunk(ids, maxChunkSize);
            const promises = chunks.map((chunk) => coreApi.query(modelName, {
              ids: chunk,
              include_pathways: includePathways,
            }, { page: { number: 1, size: chunk.length } }));

            return Promise.all(promises).then((responses) => ({
              data: {
                data: _.compact(responses.flatMap((res) => _.get(res, 'data.data', []))),
              },
            }));
          },
        }),
      ]);

      dispatch({
        type: FETCH_SERVICE_CASES,
        contactId,
        payload: response,
      });

      dispatch({ type: UNSET_FETCH_SERVICE_CASES });
      return response;
    } catch (error) {
      dispatch({ type: UNSET_FETCH_SERVICE_CASES });
      Notifier.handleErrors(error);
      return error;
    }
  };
}
